import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import { useFormikContext } from 'formik';
import React from 'react';
import { useObservable } from 'react-use-observable';
import useBoolean from 'v2/hooks/useBoolean';
import selectAffiliateService from 'v2/services/affiliate/selectAffiliate';

import type { IAffiliateOption } from 'v2/interfaces/affiliate/selectAffiliate';

import { Dialog } from './Dialog';
import { useStyles } from './styles';

import type { FieldProps } from 'formik';

type IProps = FieldProps;

export const SelectAffiliate = ({ form, field }: IProps) => {
  if (!form || !field) {
    throw new Error('You must provide a Formik Provider in order to use this component');
  }

  const { setFieldValue } = useFormikContext();

  const classes = useStyles();

  const selectedAffiliates = field?.value as IAffiliateOption[];

  useObservable(() => selectAffiliateService.loadAffiliates(), []);
  const [isLoadingAffiliates] = useObservable(() => selectAffiliateService.getIsLoading(), []);

  const [isModalOpen, setModalState] = useBoolean();

  const selectedAffiliatesQuantity = selectedAffiliates.length;
  const hasSelectAffiliates = selectedAffiliatesQuantity;
  const tooltipTitle = selectedAffiliates.map(({ id, name }, index) => {
    const limit = 25;

    if (index < limit) {
      return <p key={id}>{name}</p>;
    }

    if (index === limit) {
      return <p>...</p>;
    }

    return null;
  });

  const handleUncheckAll = () => setFieldValue(field?.name, []);

  return (
    <>
      <InputLabel htmlFor='select-affiliates-input' shrink>
        Afiliados
      </InputLabel>

      <Paper className={classes.rootInput}>
        <Tooltip
          title={tooltipTitle}
          placement='bottom'
          disableFocusListener={!hasSelectAffiliates}
          disableHoverListener={!hasSelectAffiliates}
          disableTouchListener={!hasSelectAffiliates}
        >
          <InputBase
            className={classes.input}
            placeholder={isLoadingAffiliates ? 'Carregando seus afiliados...' : 'Selecione seus afiliados'}
            value={hasSelectAffiliates ? `${selectedAffiliatesQuantity} Afiliado(s) ...` : ''}
            inputProps={{
              id: 'select-affiliates-input',
              'aria-label': 'Selecione seus afiliados',
              className: classes.inputProduct,
              onClick: setModalState.toTrue,
            }}
          />
        </Tooltip>

        <IconButton className={classes.button} aria-label='search' onClick={setModalState.toTrue}>
          <SearchIcon className={classes.iconButton} />
        </IconButton>

        {!!hasSelectAffiliates && (
          <>
            <Divider className={classes.divider} orientation='vertical' />
            <IconButton className={classes.button} color='primary' aria-label='close' onClick={handleUncheckAll}>
              <CloseIcon className={classes.iconButton} />
            </IconButton>
          </>
        )}
      </Paper>

      <Dialog
        isOpen={isModalOpen}
        onClose={setModalState.toFalse}
        selectedQuantity={selectedAffiliatesQuantity}
        selectedAffiliates={selectedAffiliates}
        handleUncheckAll={handleUncheckAll}
      />
    </>
  );
};
